/**
 * Grouped by what it's for, not by self-assigned proficiency. Ratings like
 * "Novice" invite doubt and mean nothing to a reader; the work speaks instead.
 */
export const skills = [
  {
    group: 'Languages',
    items: ['TypeScript', 'JavaScript', 'Python', 'C#', 'Go', 'PHP', 'Java', 'C++', 'SQL'],
  },
  {
    group: 'Frontend',
    items: ['React', 'React Native', 'Next.js', 'Tailwind', 'HTML', 'CSS'],
  },
  {
    group: 'Backend & data',
    items: [
      'Node.js',
      'Express',
      '.NET',
      'ASP.NET Core',
      'Prisma',
      'PostgreSQL',
      'MySQL',
      'NeptuneDB',
      'Redis',
      'Event-driven architecture',
      'SNS / SQS',
      'Multi-tenancy',
      'OpenTelemetry',
    ],
  },
  {
    group: 'Infrastructure',
    items: [
      'AWS',
      'Azure',
      'Terraform',
      'Terragrunt',
      'Docker',
      'Kubernetes',
      'Helm',
      'KEDA',
      'ECS Fargate',
      'Lambda',
      'GitHub Actions',
    ],
  },
  {
    group: 'Security',
    items: ['OIDC / SSO', 'OAuth2 / PKCE', 'JWT', 'Veracode', 'Wiz', 'Aqua', 'SAST / SCA', 'Vulnerability management'],
  },
]
